import React, { useEffect, useState, useCallback } from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import _ from "lodash";
import * as actions from "../Common/actions";
import { toastError, toastSuccess } from "../../utils";
import Pagination from "@mui/lab/Pagination";
import TextField from "@mui/material/TextField";
import CustomShowModal from "../Common/customShowModal";

const CssTextField = styled(TextField)({
  // background: "transparent",
  fontFamily: "'DM Sans', sans-serif",
  color: "#fff",
  width: "100%",
  "& label": {
    fontFamily: "'DM Sans', sans-serif",
    // color: '#10baa8',
    color: "white",
  },
  "& label.Mui-focused": {
    // color: '#10baa8',
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "red",
  },
  "& .MuiOutlinedInput-root": {
    // '& fieldset': {
    // borderColor: 'white',
    // },
    // '&:hover fieldset': {
    // borderColor: 'white',
    // },
    "&.Mui-focused fieldset": {
      borderColor: "#10baa8",
      borderWidth: "1px",
    },
  },
});

function Payout(props) {
  const [payouts, setPayouts] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    user_id: "",
    request_id: "",
    userEmail: "",
    utr: "",
    ref: "",
    amt: "",
  });
  const [withdrawOld, setWithdrawOld] = useState([]);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({
    limit: 50,
    offset: 0,
    page: 1,
    search: "",
  });

  const [conversionRate, setConvRate] = useState("");

  useEffect(() => {
    getAllPayouts();
  }, []);

  const getAllPayouts = () => {
    props.setLoader(true);
    actions.checkAwayStatus().then((res) => {
      setConvRate(res.body.conversionRate);
    });
    actions
      .getWithdrawRequestAdmin()
      .then((res) => {
        props.setLoader(false);
        setPayouts(res.body);
      })
      .catch((err) => {
        toastError(err.message);
        props.setLoader(false);
      });
  };

  const onClickSettleAndEmail = () => {
    if (!selectedItem.utr || !selectedItem.ref || !selectedItem.amt) {
      toastError("Input is required");
    }
    if (selectedItem.utr && selectedItem.ref && selectedItem.amt) {
      onConfirmSettle();
    }
  };

  const onClickSettle = (item) => {
    setSelectedItem({
      user_id: item.user_id,
      request_id: item.request_id,
      userEmail: item.email,
    });
    setConfirmOpen(true);
  };

  const onConfirmSettle = () => {
    props.setLoader(true);
    actions
      .sentMoneyByAdmin(selectedItem)
      .then((res) => {
        props.setLoader(false);
        toastSuccess(res.message);
        setConfirmOpen(false);
        getAllPayouts();
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
        setConfirmOpen(false);
      });
  };

  let totalPages = Math.ceil(Number(count) / filters.limit);

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    onGetWithdrawCOld(newFilters);
  };

  const onGetWithdrawCOld = (filters) => {
    props.setLoader(true);
    actions
      .getWithdrawHistoryAdmin({ ...filters })
      .then((res) => {
        props.setLoader(false);
        setWithdrawOld(res.body);
        setCount(res.total);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  const delaySearch = useCallback(
    _.debounce((filters) => onGetWithdrawCOld(filters), 500),
    []
  );

  const onChangeSearch = (e) => {
    const newFilters = { ...filters, search: e.target.value };
    setFilters(newFilters);
    delaySearch(newFilters);
  };

 const onUpdateRate = () => {
    props.setLoader(true);
    actions
      .updateConversionRateAdmin({conversionRate: conversionRate})
      .then((res) => {
        props.setLoader(false);
        toastSuccess(res.message);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  useEffect(() => {
    onGetWithdrawCOld(filters);
    setTimeout(() => {
      props.setLoader(false);
    }, 5000);
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <p style={{ fontWeight: 500 }}>Review Required</p>

        <Box mt={2} display="flex" alignItems="center">
          {/* Search takes 70% */}
          <CssTextField
            type="text"
            variant="outlined"
            size="small"
            onChange={onChangeSearch}
            value={filters.search}
            placeholder="Search..."
            style={{ flex: 7, marginRight: 10 }}
          />

          {/* Right side (Conversion + Button) takes 30% */}
          <Box display="flex" alignItems="center" style={{ flex: 1.6 }}>
            <TextField
              label="Conversion Rate"
              variant="outlined"
              size="small"
              value={conversionRate}
              style={{ marginRight: 10, flex: 1 }}
              onChange={(e) => setConvRate(e.target.value)}
            />

            <Button
              variant="contained"
              color="primary"
              onClick={onUpdateRate}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} style={{ marginTop: "10px", marginBottom: "10px" }}>
        <Box>
          <TableContainer component={Paper}>
            <Table className="universal-table">
              <TableHead>
                <TableRow
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
                  }}
                >
                  <TableCell className="color-white">No.</TableCell>
                  <TableCell className="color-white">Name</TableCell>
                  <TableCell className="color-white">Email</TableCell>
                  <TableCell className="color-white">Phone</TableCell>
                  <TableCell className="color-white">Revenue</TableCell>
                  <TableCell className="color-white">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payouts.length ? (
                  payouts.map((item, key) => {
                    return (
                      <TableRow key={key}>
                        <TableCell>{key + 1}</TableCell>
                        <TableCell>{item.name || "-"}</TableCell>
                        <TableCell>{item.email || "-"}</TableCell>
                        <TableCell>{item.phone || "-"}</TableCell>
                        <TableCell>{item.revenue || "-"}</TableCell>
                        <TableCell>
                          <button
                            className="settle-payout"
                            onClick={() => onClickSettle(item)}
                          >
                            SETTLE
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan="8" align="center">
                      No Request Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>

      <Grid item xs={12} style={{ marginTop: "20px" }}>
        <h2
          style={{
            fontWeight: 500,
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          Payout History
        </h2>
        <TableContainer component={Paper}>
          <Table className="universal-table">
            <TableHead>
              <TableRow
                style={{
                  background:
                    "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
                }}
              >
                <TableCell className="color-white">User ID</TableCell>
                <TableCell className="color-white">Name</TableCell>
                <TableCell className="color-white">Email</TableCell>
                <TableCell className="color-white">UTR</TableCell>
                <TableCell className="color-white">REF</TableCell>
                <TableCell className="color-white">Email Amount</TableCell>
                <TableCell className="color-white">Amount</TableCell>
                <TableCell className="color-white">Settled On</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {withdrawOld.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{item.user_id}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item.utr}</TableCell>
                    <TableCell>{item.ref}</TableCell>
                    <TableCell>{item.email_amt}</TableCell>
                    <TableCell>{item.amount}</TableCell>
                    <TableCell>{item.settled_on}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Pagination
            count={totalPages}
            showFirstButton
            showLastButton
            onChange={onPageChange}
            page={filters.page || 0}
          />
        </TableContainer>
      </Grid>

      <CustomShowModal
        handleClose={() => setConfirmOpen(false)}
        title={"Send an email to user or just settle ?"}
        open={confirmOpen}
        maxWidth="sm"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <TextField
            label="UTR Number"
            variant="outlined"
            value={selectedItem.utr}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                utr: e.target.value,
              }))
            }
            fullWidth
          />
          <TextField
            label="Reference Number"
            variant="outlined"
            value={selectedItem.ref}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                ref: e.target.value,
              }))
            }
            fullWidth
          />
          <TextField
            label="Transfer Amount"
            variant="outlined"
            value={selectedItem.amt}
            onChange={(e) =>
              setSelectedItem((prev) => ({
                ...prev,
                amt: e.target.value,
              }))
            }
            fullWidth
          />
        </div>

        <div
          className="aceept-reject-button"
          style={{ marginTop: "1.5rem", display: "flex", gap: "1rem" }}
        >
          <button className="accept" onClick={onClickSettleAndEmail}>
            Send Email
          </button>
          <button className="accept" onClick={onConfirmSettle}>
            Just Settle
          </button>
        </div>
      </CustomShowModal>
    </Grid>
  );
}

export default Payout;
